import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import numeral from 'numeral';
import moment from 'moment';

import { setPortal } from 'modules/portal';
import { ManageGoodsInfoReviewAdver } from 'lib/api/goods';
import { makeRowColumn, getDate, getHeadObj } from 'lib/commonLib';

import TopTextArea from 'components/molecules/MbTable/TopTextArea';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
import NewTableContainer from 'components/molecules/NewTable';
import IconAreaWrap from 'components/molecules/MbTable/IconAreaWrap';

const ProductManagementGoodsInfoReviewAdver = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { portal } = useSelector(({ portal }) => ({
    portal: portal,
  }));
  const initParams = {
    sort: 'desc',
    order: 'REVW_CNT',
    sDate: getDate(moment(moment().format('YYYY-MM-01'))),
    eDate: getDate(moment()),
  };

  const [params, setParams] = useState(initParams);
  const [initialization, setInitialization] = useState(false);

  const [subData, setSubData] = useState('');

  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    }
  }, [initialization]);

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    if (JSON.stringify(params) !== JSON.stringify(initParams)) {
      setInitialization(true);
      setParams(initParams);
    }
  };

  /**
   * 페이지 파라미터를 관리하는 params을 수정하는 함수
   * @param newParams
   */
  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  /**
   * subData처리
   */
  const useSubData = (subData) => {
    const newSubData =
      t('리뷰수집 광고주수') +
      ' : ' +
      numeral(subData.adverCnt).format('#,##0') +
      t('개') +
      ' / ' +
      t(' 리뷰수집 상품수') +
      ' : ' +
      numeral(subData.prdtCnt).format('#,##0') +
      t('개');
    setSubData(newSubData);
  };

  // header 및 body 컬럼 커스텀
  const customized = {
    ADVER_ID: {
      makeBody: (rowObj, headsMap) => {
        let resultComponent;
        const bodyItem1 = getHeadObj(headsMap, 'ADVER_ID');
        const showWindowUrl =
          '/product/collection/goodsinfo/reviewProduct?isPop=1&sDate=' +
          params.sDate +
          '&eDate=' +
          params.eDate +
          '&adverId=' +
          rowObj['ADVER_ID'];

        resultComponent = (
          <IconAreaWrap
            text={makeRowColumn(
              rowObj['ADVER_ID'],
              bodyItem1.type,
              bodyItem1.format
            )}
            icon={'faExternalLink'}
            toolTipTitle={t('해당 카테고리의 컨버전 내역 팝업')}
            onClick={(e) => handlePortalUrl(showWindowUrl)}
          />
        );
        return resultComponent;
      },
      bodyStyle: { width: 200 },
    },
    REVW_PRDT_CNT: {
      makeBody: (rowObj, headsMap) => {
        return numeral(rowObj['REVW_PRDT_CNT']).format('#,##0');
      },
      orderFlag: true,
    },
    REVW_AVG: {
      makeBody: (rowObj, headsMap) => {
        return rowObj['REVW_AVG'];
      },
      orderFlag: true,
    },
  };

  const handlePortalUrl = (url) => {
    let newPortal = portal.portal;
    let popIndex = newPortal.length;
    newPortal[popIndex] = { url: url, cnt: popIndex };
    dispatch(setPortal(newPortal));
  };

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          getParam={getParam}
          params={params}
          useDisplayFilter={false}
          useExternalFilter={false}
          usePltfomTpCodeFilter={false}
        />
      </NewFilterWrap>
      <TopTextArea subData={subData} />
      <NewTableContainer
        params={params}
        getParam={getParam}
        dataReqPromise={ManageGoodsInfoReviewAdver}
        customized={customized}
        useTotal={false}
        dataCallBack={useSubData}
        useFetch={false}
        toolTip={t('리뷰를 수집하고 있는 광고주 정보를 보실수 있습니다.')}
      />
    </>
  );
};

export default ProductManagementGoodsInfoReviewAdver;
